import { ControlText } from '@mint/ui';

export const AdminModalText = ControlText;
